import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';
import NotificationService from '../../../core/services/NotificationService';
import { isRequired } from '../../../core/validations';
import { browserHistory } from 'react-router';
import orderBy from 'lodash/orderBy';

export default class VocabularyFormService {
  fetch = new FetchService();
  submit = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      vocabularyId: null,
      vocabularyThemes: [],
      academicPlans: [],
    });
    this.form.validations = {
      text: [isRequired],
      translate: [isRequired],
      image: [isRequired],
      sentence: [isRequired],
      vocabularyTheme: [isRequired],
      academicPlan: [isRequired],
    };
  }

  handleLoad = action((vocabularyId) => {
    this.form.reset();
    if (vocabularyId) {
      this.fetch
        .fetch({
          apiVersion: 'v3',
          url: `/vocabularies/${vocabularyId}`,
        })
        .then(() => {
          if (this.fetch.data) {
            this.form.setInitialValues(this.fetch.data);
          }
        });
    } else {
      this.form.setInitialValues({});
    }
    this.fetch
      .fetch({
        apiVersion: 'v3',
        url: '/vocabulary-themes',
        query: {
          page: 1,
          size: 999,
        },
      })
      .then((data) => {
        this.vocabularyThemes = orderBy(data.docs, ['name'], ['asc']);
      });
  });

  handleSubmit = action(() => {
    this.form.submitted = true;
    if (this.form.errors) {
      NotificationService.addNotification('Fill the required fields', 'error');
      return;
    }
    const vocabularyId = this.form.getValue('id');

    const fileData = new FormData();
    fileData.append('image', this.form.getValue('image'));
    fileData.append('text', this.form.getValue('text'));
    fileData.append('translate', this.form.getValue('translate'));
    fileData.append('sentence', this.form.getValue('sentence'));
    fileData.append('vocabularyTheme', this.form.getValue('vocabularyTheme'));
    fileData.append('academicPlan', this.form.getValue('academicPlan'));

    this.submit
      .fetch({
        apiVersion: 'v3',
        method: vocabularyId ? 'put' : 'post',
        url: vocabularyId ? `/vocabularies/${vocabularyId}` : '/vocabularies',
        body: fileData,
      })
      .then(() => {
        if (this.submit.data) {
          NotificationService.addNotification(
            `Vocabulary ${vocabularyId ? 'updated' : 'created'} successfully.`,
            'success'
          );
          browserHistory.replace(`/vocabularies`);
        }
        if (this.submit.error) {
          NotificationService.addNotification(`Error ${vocabularyId ? 'updating' : 'creating'} vocabulary.`, 'error');
        }
      });
  });
}
